/**
 * OAuth client ids.
 *
 * These are public identifiers, not secrets — the whole point of PKCE is that a
 * browser app needs no secret. They are still per-deployment, because each is
 * tied to a redirect URI registered with the provider, so a fork running on
 * another domain needs its own.
 *
 * Registering them is a human step at each provider's developer console; see
 * `docs/ONE_CLICK_STORAGE.md`. A provider with an empty id shows as "needs
 * setup" in the UI rather than failing at the moment someone clicks connect.
 *
 * Vite inlines `import.meta.env.VITE_*` at build time, so these can be supplied
 * per environment without editing this file.
 */
// `import.meta.env` only exists under Vite. Guarded so the module can also be
// imported by tests and tooling, where its absence would otherwise throw at
// import time and take every provider down with it.
const env: Record<string, string | undefined> =
  (import.meta as { env?: Record<string, string | undefined> }).env ?? {};

export const CLIENT_IDS = {
  dropbox: env.VITE_DROPBOX_CLIENT_ID ?? '',
  googledrive: env.VITE_GOOGLE_CLIENT_ID ?? '',
  onedrive: env.VITE_ONEDRIVE_CLIENT_ID ?? '',
} as const;
